var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BaseRequestPolicy, } from '@azure/ms-rest-js';
export class CustomHeaderPolicy extends BaseRequestPolicy {
    // eslint-disable-next-line max-params
    constructor(nextPolicy, options, headerKey, headerValue) {
        super(nextPolicy, options);
        this.headerKey = headerKey;
        this.headerValue = headerValue;
    }
    sendRequest(request) {
        return __awaiter(this, void 0, void 0, function* () {
            this.addCustomHeader(request);
            return this._nextPolicy.sendRequest(request);
        });
    }
    addCustomHeader(request) {
        if (!request.headers.get(this.headerKey) && this.headerValue) {
            request.headers.set(this.headerKey, this.headerValue);
        }
    }
}
